<template>
  <div class="settings-container tw-col-span-3">
    <profile-settings></profile-settings>
  </div>
</template>

<script>
import profileSettings from "./subcomponents/profile-settings.vue";

export default {
  components: {
    profileSettings,
  },
  created() {
    this.$store.dispatch("getDonorAccountInfo");
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/_vars.scss";
.settings-container {
  padding: 45px 35px;
  box-shadow: 0 8px 32px 0 rgba(35, 40, 71, 0.08);
  background-color: #ffffff;
  .bttn--orange {
    background-color: #ff5555;
    &:hover {
      opacity: 0.85;
    }
  }
  .account-card {
    box-shadow: none;
    border-bottom: 1px solid #e6eaed;
    .card-footer {
      padding-top: 0;
      padding-bottom: 30px;
    }
    .card-body {
      padding-bottom: 0;
    }
  }
}
</style>
